import { Box, Center, Text, VStack } from '@chakra-ui/react';

import { KybDocument } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import Loader from 'components/Loader';
import OBFileItem from 'features/Onboarding/components/OBFileItem';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import ShortenedDivider from 'features/Onboarding/components/ShortenedDivider';

import locales from './locales';

const FAQ_HREF =
  'http://help.shine.fr/fr/articles/3693082-comment-transmettre-les-statuts-de-ma-societe-pour-ouvrir-mon-compte-shine';

interface StatutesIntroProps {
  onContinue: () => void;
  isSending: boolean;

  review?: {
    document: Pick<
      KybDocument,
      'kybDocumentId' | 'status' | 'type' | 'url' | 'errorLocalized'
    >;
    onDelete: (documentId: string) => void;
    isDeleting: boolean;
  };
}

const StatutesHub = asBentoPage<StatutesIntroProps>(
  ({ isSending, Layout, onContinue, onPrev, review }) => {
    let center = null;

    if (isSending) {
      center = (
        <Box>
          <Loader />
        </Box>
      );
    } else if (review?.document.errorLocalized) {
      center = (
        <VStack align="stretch" spacing="space-40">
          <Callout variant="error">
            <Callout.Title>{locales.refusedLabel}</Callout.Title>

            <Callout.Content>{review.document.errorLocalized}</Callout.Content>
          </Callout>

          <SunshineCard onClick={onContinue} title={locales.addDocumentAction}>
            <SunshineCard.Slot name="action">
              <SunshineCard.SunshineIcon name="chevron-right" />
            </SunshineCard.Slot>
          </SunshineCard>
        </VStack>
      );
    } else if (review) {
      center = (
        <VStack align="stretch" spacing="space-40">
          <Box>
            <OBFileItem
              fileName={locales.statutesDocumentName}
              isLoading={review.isDeleting}
              onDeleteClick={() =>
                review.onDelete(review.document.kybDocumentId)
              }
              onPreviewClick={() =>
                review.document.url &&
                window.open(review.document.url, '_blank')
              }
            />
          </Box>

          <Center>
            <Button isExpanded onClick={onContinue}>
              {locales.ctaContinue}
            </Button>
          </Center>
        </VStack>
      );
    } else {
      center = (
        <SunshineCard onClick={onContinue} title={locales.addDocumentAction}>
          <SunshineCard.Slot name="action">
            <SunshineCard.SunshineIcon name="chevron-right" />
          </SunshineCard.Slot>
        </SunshineCard>
      );
    }

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Box>
          <Heading size="lg">{locales.title}</Heading>

          <ShortenedDivider marginY="space-20" />

          <Text>{locales.aboutStatutes}</Text>

          <Button
            as="a"
            href={FAQ_HREF}
            icon="link"
            marginY="space-16"
            target="_blank"
            variant="inline-primary"
          >
            {locales.faqQuestions}
          </Button>

          {center}
        </Box>
      </Layout>
    );
  },
);

export default StatutesHub;
